module.exports = __webpack_public_path__ + "static/media/align_left_dark.794425ac.svg";